<template>
    <div :class="classes">
        <slot></slot>
    </div>
</template>
<script>
    import theme from './grid.scss';

    export default {
        name: 'row',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
            alignItems: String, // start, center, end
            justifyContent: String, // start, center, end, around, between
        },
        computed: {
            classes() {
                return {
                    [this.theme.row]: true,
                    [this.theme['align-items-' + this.alignItems]]: this.alignItems !== undefined,
                    [this.theme['justify-content-' + this.justifyContent]]: this.justifyContent !== undefined,
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Row.vue?482f6faf